import { EventMarkerLayer, PitchViz } from '@statsbomb/kitbag-datavis';
import { SHOT_MAP_GOAL_DASHARRAY, SHOT_MAP_MARKER_STROKE_WIDTH } from '@/consts/visualisations';
import { useShotMarkerColours } from '@/hooks/shotMap/useShotMarkerColours';
import { useGetPitchRotation } from '@/hooks/useGetPitchRotation';
import { usePitchCrop } from '@/hooks/usePitchCrop';
import { ShotMapEventMarker } from '@/types/visualisation';
import { getShotMarkerShape } from '@/utils/visualisations';

export const ShotMap = ({ events }: { events: ShotMapEventMarker[] }) => {
  const pitchRotation = useGetPitchRotation(false);
  const visibleArea = usePitchCrop(false);
  const { getShotMarkerFill, getShotMarkerStroke } = useShotMarkerColours();
  const rotation = pitchRotation === 'VERTICAL' || pitchRotation === 'VERTICAL_REVERSE' ? 90 : undefined;

  const ShotMapMarkersLayer = (
    <EventMarkerLayer
      markers={events.map(marker => ({
        id: marker.eventId,
        x: marker.startX,
        y: marker.startY,
        radius: 0.9,
        rotation,
        fill: getShotMarkerFill(marker),
        stroke: getShotMarkerStroke(marker),
        strokeWidth:
          marker.outcome === 'goal' ? SHOT_MAP_MARKER_STROKE_WIDTH.GOAL : SHOT_MAP_MARKER_STROKE_WIDTH.DEFAULT,
        strokeDasharray: marker.outcome === 'goal' ? SHOT_MAP_GOAL_DASHARRAY : undefined,
        shapeName: getShotMarkerShape(marker),
      }))}
    />
  );

  return (
    <figure className="h-full">
      <PitchViz
        rotationName={pitchRotation}
        pitchFocusZoneName={visibleArea}
        overlay={ShotMapMarkersLayer}
        className="h-full w-full"
      />
    </figure>
  );
};
